interface ActionTypes {
  GET_USERS_START: string;
  GET_USERS_SUCCESS: string;
  GET_USERS_FAILURE: string;
  GET_USERS_RESET: string;
  GET_USER_DETAILS_START: string;
  GET_USER_DETAILS_SUCCESS: string;
  GET_USER_DETAILS_FAILURE: string;
  GET_USER_DETAILS_RESET: string;
  FREE_PLAN_UPGRADE_START: string;
  FREE_PLAN_UPGRADE_SUCCESS: string;
  FREE_PLAN_UPGRADE_FAILURE: string;
  FREE_PLAN_UPGRADE_RESET: string;
}

export const SysAdminUserActionTypes: ActionTypes = {
  GET_USERS_START: '@@GET_USERS_START',
  GET_USERS_SUCCESS: '@@GET_USERS_SUCCESS',
  GET_USERS_FAILURE: '@@GET_USERS_FAILURE',
  GET_USERS_RESET: '@@GET_USERS_RESET',
  GET_USER_DETAILS_START: '@@GET_USER_DETAILS_START',
  GET_USER_DETAILS_SUCCESS: '@@GET_USER_DETAILS_SUCCESS',
  GET_USER_DETAILS_FAILURE: '@@GET_USER_DETAILS_FAILURE',
  GET_USER_DETAILS_RESET: '@@GET_USER_DETAILS_RESET',
  FREE_PLAN_UPGRADE_START: '@@FREE_PLAN_UPGRADE_START',
  FREE_PLAN_UPGRADE_SUCCESS: '@@FREE_PLAN_UPGRADE_SUCCESS',
  FREE_PLAN_UPGRADE_FAILURE: '@@FREE_PLAN_UPGRADE_FAILURE',
  FREE_PLAN_UPGRADE_RESET: '@@FREE_PLAN_UPGRADE_RESET'
};

export interface SysAdminUserState {
  users?: { count: number; data: any[] };
  getUsersStatus: 'initial' | 'fetching' | 'success' | 'failed';
  userDetails?: any;
  getUserDetailsStatus: 'initial' | 'fetching' | 'success' | 'failed';
  organisationGroups: any[];
  createOrgsStatus: 'initial' | 'creating' | 'success' | 'failed';
  createOrgsError?: string;
  getOrgGroupsStatus: 'initial' | 'fetching' | 'success' | 'failed';
  reloadTrigger: number;
}
